// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__5RrQe","detailsBorder":"styles_detailsBorder__2bmcm"};